import Icon from "@/components/Icon/Icon";
import { Text } from "@/components/Typography/Text";
import { Select, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useCommonTranslation } from "@/hooks/useCommonTranslation";
import { defaultNS, useTranslation } from "@/lib/i18n";

export const WaitingDependencyPresentation = ({
  testId,
  currentValue,
  currentValueLabel,
}: {
  testId?: string;
  currentValue: string | undefined;
  currentValueLabel?: string;
}) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "features.formFactory.dynamicSelectField.error",
  });
  const tc = useCommonTranslation();

  const displayCurrentValue =
    currentValueLabel ?? currentValue ?? tc("unregistered");

  return (
    <div className="flex items-center justify-center w-full gap-4">
      {/* 現在の値（読み取り専用のテキスト表示） */}
      <div className="flex-1 flex justify-start min-w-0">
        <Text
          variant="labelSemiLarge"
          className="text-neutral-on-fill wrap-break-word"
        >
          {displayCurrentValue}
        </Text>
      </div>

      {/* Arrow Icon */}
      <div className="flex items-center shrink-0 self-center pr-3 pl-3">
        <Icon
          iconName="ArrowBigRightIcon"
          className="w-4 h-4 text-primary-on-neutral-fill"
        />
      </div>

      {/* 新しい値の選択（無効化状態） */}
      <div className="flex-1 min-w-0">
        <Select disabled>
          <SelectTrigger
            className="w-full"
            data-testid={testId}
            data-role="form-field-input"
          >
            <SelectValue placeholder={t("selectDependencyFirst")} />
          </SelectTrigger>
        </Select>
      </div>
    </div>
  );
};
